/**
 * Menu Management Module
 * Handles loading, filtering, creating, editing, and deleting menu items.
 */

export class MenuModule {
  constructor() {
    this.menuItems = [];
    this.activeFilter = "";
  }

  setMenuItems(items) {
    this.menuItems = Array.isArray(items) ? items : [];
  }

  filterMenuItems(query = "", mealType = "", country = "", availability = "all") {
    return this.menuItems.filter((item) => {
      if (!item) return false;

      // Text query match
      if (query) {
        const q = query.toLowerCase();
        const titleMatch = item.title && item.title.toLowerCase().includes(q);
        const descMatch = item.description && item.description.toLowerCase().includes(q);
        const providerMatch = item.providerName && item.providerName.toLowerCase().includes(q);
        if (!titleMatch && !descMatch && !providerMatch) return false;
      }

      // Meal type match
      if (mealType && item.mealType !== mealType) {
        return false;
      }

      // Country match
      if (country && item.country !== country) {
        return false;
      }

      // Availability filter
      if (availability === "247" && !item.is247) return false;
      if (availability === "dailySpecial" && !item.isDailySpecial) return false;

      return true;
    });
  }
}

export const menuModule = new MenuModule();
